/*
路由器模块
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Catail from "../pages/Catail/Catail";
import Test from "../pages/Test/Test";


// let url = window.location.href;
let bookid ;

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

const router =  new VueRouter({
    routes: [
        {
            path: '/test',
            name:'test',
            component: Test
        },
        {
            path: '/catail/:bookid',
            name:'catail',
            component: Catail
        }
    ],
    bookid,
});


export default router

